module.exports = __webpack_public_path__ + "img/16.9a34d840.png";